import { graphql } from '@predium/client-graphql';

graphql(`
  fragment CustomTarget on CustomTarget {
    active
    id
    name
    target_definitions {
      id
      target_definition_type
      value
      year
    }
  }
`);

export const GET_ALL_CUSTOM_TARGETS = graphql(`
  query GetAllCustomTargets {
    getAllCustomTargets {
      ...CustomTarget
    }
  }
`);

export const GET_ACTIVE_CUSTOM_TARGET = graphql(`
  query GetActiveCustomTarget {
    getActiveCustomTarget {
      ...CustomTarget
    }
  }
`);

export const GET_ALL_CUSTOM_FIELDS = graphql(`
  query GetAllCustomFields($entityType: custom_field_entity_enum!) {
    custom_field(where: { entity_type: { _eq: $entityType } }, order_by: { name: asc }) {
      id
      key
      name
      type_id
      entity_type
      suffix
      show_in_analysis
    }
  }
`);
